import { render, staticRenderFns } from "./AdminViewModeToggle.vue?vue&type=template&id=a51dcdea"
import script from "./AdminViewModeToggle.vue?vue&type=script&lang=js"
export * from "./AdminViewModeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2401775778/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a51dcdea')) {
      api.createRecord('a51dcdea', component.options)
    } else {
      api.reload('a51dcdea', component.options)
    }
    module.hot.accept("./AdminViewModeToggle.vue?vue&type=template&id=a51dcdea", function () {
      api.rerender('a51dcdea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AdminViewModeToggle.vue"
export default component.exports